import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../../theme/css/theme.css";

export const containerStyle = style({
  paddingLeft: `calc(${theme.spacings.m} + ${theme.spacings.s})`,
  position: "relative",
  selectors: {
    "&:before": {
      content: "•",
      lineHeight: 0,
      fontSize: rem(20),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: theme.spacings.m,
      height: theme.spacings.m,
      border: `${rem(2)} solid ${theme.colors.inputBorderFocus}`,
      color: theme.colors.inputBorderFocus,
      backgroundColor: theme.colors.background,
      position: "absolute",
      left: 0,
      top: rem(-4),
      borderRadius: "50%",
      zIndex: 1,
    },
    "&:not(:last-child):after": {
      content: "",
      position: "absolute",
      left: `calc(${theme.spacings.m} / 2)`,
      top: `calc(${theme.spacings.m} / 2)`,
      width: rem(2),
      backgroundColor: theme.colors.inputBorderFocus,
      height: `calc(100% + ${theme.spacings.m})`,
      zIndex: 0,
    },
  },
});
